import React from 'react';
import { Viewport } from '../utils';
import NotSmall from './NotSmall';
import Small from './Small';

interface Clipboard {
  writeText(newClipText: string): Promise<void>;
}

interface NavigatorClipboard extends Navigator {
  readonly clipboard?: Clipboard;
}

export interface NavigatorExtended extends NavigatorClipboard {}

const NoteReadOnly = (props: any) => (
  <Viewport small={<Small {...props} />} notSmall={<NotSmall {...props} />} />
);

export default NoteReadOnly;
